"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var message_1 = require("../../model/message");
var service_1 = require("../../../library/base/service");
var CenterDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CenterDetail, _super);
    function CenterDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '消息中心详情查询';
        _this.code = '101009';
        _this.desc = '消息中心详情查询';
        _this.requestParams = new message_1.CenterDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CenterDetail;
}(service_1.BaseService));
exports.CenterDetail = CenterDetail;
//# sourceMappingURL=centerDetail.js.map